import { SVGProps } from 'react';

const Plus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    className={props.className}
    onClick={props.onClick}
    fill={props.fill || 'currentColor'}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || 20}
    height={props.height || 20}
    {...props}>
    <path d="M19 11h-6V5a1 1 0 0 0-2 0v6H5a1 1 0 0 0 0 2h6v6a1 1 0 0 0 2 0v-6h6a1 1 0 0 0 0-2z" />
  </svg>
);

export default Plus;
